export default __webpack_public_path__ + "images/631f33419ded7183aab82c74fc170907-senior_citizen.jpg";